import React, { useState } from "react";
import "./Footer.css";
import "../Navigation/Btn.css";
import LOGO from "../Navigation/IMG/LOGO1.png";
import { Icon } from "@iconify/react";
import linkedinBoxFill from "@iconify/icons-ri/linkedin-box-fill";
import instagramAlt from "@iconify/icons-uil/instagram-alt";
import socialFacebook from "@iconify/icons-foundation/social-facebook";
import { Link } from "react-router-dom";

function Footer() {
  const [email, setEmail] = useState("");

  return (
    <>
      <footer className="Vb081wq">
        <div className="JHDF982">
          <div className="Vagd1">
            <img className="Gak091" src={LOGO} alt="Quarec Resources" />
            <p className="gsdfSqaz">
              Connecting talent
              <br /> to opportunity - <br />
              “Your pathway to success.”
            </p>
          </div>
          <div className="Hrapavil">
            <div className="Vagd2">
              <h2 className="JDF09237">Quick Links</h2>
              <div className="GDFiww0891">
                <Link to="/" className="VajHov">Home</Link>
                <Link to="/AboutUs" className="VajHov">About Us</Link>
                <Link to="/Blog" className="VajHov">Hiring &amp; Career Guides</Link>
                <Link to="/Resources" className="VajHov">Hiring &amp; Career Resources</Link>
                <Link to="/Careers" className="VajHov">Careers</Link>
                <Link to="/ContactUs" className="VajHov">Contact Us</Link>
              </div>
            </div>
            <div className="Vagd">
              <h2 className="JDF09237">Services</h2>
              <div className="GDFiww0891">
                <Link to="/PermanentStaffing" className="VajHov">Permanent Staffing</Link>
                <Link to="/TemporaryStaffing" className="VajHov">Temporary Staffing</Link>
                <Link to="/PayRoll" className="VajHov">Payroll Management</Link>
                <Link to="/International" className="VajHov">International Recruitment</Link>
                <Link to="/DedicatedIt" className="VajHov">Dedicated IT Resources</Link>
                <Link to="/Executive" className="VajHov">Executive Search</Link>
                <Link to="/BulkHiring" className="VajHov">Bulk Hiring</Link>
                <Link to="/VisaAssistance" className="VajHov">Visa Assistance Guidance</Link>
              </div>
            </div>
          </div>
          <div className="Hrapavil">
            <div className="Vagd">
              <h2 className="JDF09237">Important Links</h2>
              <div className="GDFiww0891">
                <Link to="/Privacypolicy" className="VajHov">Privacy Policy</Link>
                <Link to="/TermsConditions" className="VajHov">Terms &amp; Conditions</Link>
              </div>
              <div className="V0911021WJ">
                <h2 className="JDF09237">Social Links</h2>
                <div className="VCoau">
                  <a href="https://www.linkedin.com/company/quarec-resources-pvt-ltd/" target="_blank" rel="noopener noreferrer" aria-label="Quarec Resources on LinkedIn">
                    <Icon className="Vaopl" icon={linkedinBoxFill} aria-hidden="true" />
                  </a>
                  <a href="https://www.instagram.com/quarecresources/" target="_blank" rel="noopener noreferrer" aria-label="Quarec Resources on Instagram">
                    <Icon className="Vaopl" icon={instagramAlt} aria-hidden="true" />
                  </a>
                  <a href="https://www.facebook.com/quarecresources/" target="_blank" rel="noopener noreferrer" aria-label="Quarec Resources on Facebook">
                    <Icon className="Vaopl" icon={socialFacebook} aria-hidden="true" />
                  </a>
                </div>
              </div>
            </div>
            <div className="Vagd">
              <h2 className="JDF09237">Stay Updated</h2>
              <div className="GDFiww0891">
                <p className="Vd091">Subscribe to the Quarec newsletter</p>
                <form
                  action="https://quarecres.mcxcontrol.com/api/subscribers.php"
                  method="post"
                  encType="multipart/form-data"
                >
                  <label className="visually-hidden" htmlFor="quarec-newsletter-email">Email address</label>
                  <input
                    id="quarec-newsletter-email"
                    className="Vakjs01"
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    autoComplete="email"
                    required
                    name="email"
                  />
                  <button className="shin-btn" type="submit">Subscribe</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="BV0927">
        <p>Copyright © 2026 Quarec Resources | All rights reserved.</p>
      </div>
    </>
  );
}

export default Footer;
